import { render, staticRenderFns } from "./SelectAppModal.vue?vue&type=template&id=88b81922&scoped=true"
import script from "./SelectAppModal.vue?vue&type=script&lang=js"
export * from "./SelectAppModal.vue?vue&type=script&lang=js"
import style0 from "./SelectAppModal.vue?vue&type=style&index=0&id=88b81922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b81922",
  null
  
)

export default component.exports